function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { STASH, CART_ADD_LOCATION, PIP, ATC, CART_ADD } from '../constants.js';
export const toolsMaterials = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('tools-materials.get-started-click', () => {
    const getStartedButtonEvent = {
      category: {
        primaryCategory: 'overlay'
      },
      eventInfo: {
        eventName: 'project shopping drawer',
        abTest: 'get started ps drawer'
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(getStartedButtonEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('tools-materials.ps-entry-cart-add-location', _ref => {
    let {
      output = {}
    } = _ref;
    const {
      projectId,
      category
    } = output;
    const cartAddLocationEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: CART_ADD_LOCATION
      },
      eventMode: STASH,
      stash: {
        component: projectId,
        pageType: PIP,
        section: 'get started project shopping drawer',
        sharedSection: category === null || category === void 0 ? void 0 : category.toLowerCase(),
        target: ATC
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(cartAddLocationEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('tools-materials.ps-entry-cart-add-click', _ref2 => {
    var _cartResponse$CartMod, _cartResponse$CartMod2, _cartResponse$CartMod3, _info$categoryHierarc, _digitalData$cart, _digitalData$cart2;
    let {
      output = {}
    } = _ref2;
    const {
      product = {},
      cartResponse = {},
      fulfillmentOptions = {}
    } = output;
    const {
      pricing,
      itemId,
      identifiers,
      info
    } = product;
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    const basePrice = formatter.format(pricing === null || pricing === void 0 ? void 0 : pricing.value);
    const fulfillment = _objectSpread(_objectSpread({
      method: fulfillmentOptions === null || fulfillmentOptions === void 0 ? void 0 : fulfillmentOptions.method
    }, (fulfillmentOptions === null || fulfillmentOptions === void 0 ? void 0 : fulfillmentOptions.store) && {
      store: fulfillmentOptions === null || fulfillmentOptions === void 0 ? void 0 : fulfillmentOptions.store
    }), (fulfillmentOptions === null || fulfillmentOptions === void 0 ? void 0 : fulfillmentOptions.zip) && {
      zip: fulfillmentOptions === null || fulfillmentOptions === void 0 ? void 0 : fulfillmentOptions.zip
    });
    const etaObj = !!(fulfillmentOptions !== null && fulfillmentOptions !== void 0 && fulfillmentOptions.sthEndDate) && !!(fulfillmentOptions !== null && fulfillmentOptions !== void 0 && fulfillmentOptions.sthStartDate) && {
      eta: {
        sthEndDate: fulfillmentOptions === null || fulfillmentOptions === void 0 ? void 0 : fulfillmentOptions.sthEndDate,
        sthStartDate: fulfillmentOptions === null || fulfillmentOptions === void 0 ? void 0 : fulfillmentOptions.sthStartDate
      }
    };
    const cartAddClickEvent = {
      category: {
        primaryCategory: 'add to cart click'
      },
      eventInfo: {
        eventName: CART_ADD
      },
      item: [{
        productInfo: {
          sku: itemId
        },
        quantity: '1',
        price: {
          basePrice
        },
        fulfillment
      }],
      cart: {
        cartID: cartResponse === null || cartResponse === void 0 ? void 0 : (_cartResponse$CartMod = cartResponse.CartModel) === null || _cartResponse$CartMod === void 0 ? void 0 : _cartResponse$CartMod.orderId
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(cartAddClickEvent);
    const cartObj = {
      cartID: cartResponse === null || cartResponse === void 0 ? void 0 : (_cartResponse$CartMod2 = cartResponse.CartModel) === null || _cartResponse$CartMod2 === void 0 ? void 0 : _cartResponse$CartMod2.orderId,
      price: {
        cartTotal: cartResponse === null || cartResponse === void 0 ? void 0 : (_cartResponse$CartMod3 = cartResponse.CartModel) === null || _cartResponse$CartMod3 === void 0 ? void 0 : _cartResponse$CartMod3.cartTotal
      }
    };
    const cartItem = {
      fulfillment,
      price: {
        basePrice
      },
      productInfo: _objectSpread(_objectSpread({
        manufacturer: identifiers === null || identifiers === void 0 ? void 0 : identifiers.brandName,
        productName: identifiers === null || identifiers === void 0 ? void 0 : identifiers.productLabel,
        sku: itemId,
        subCategory2: info === null || info === void 0 ? void 0 : (_info$categoryHierarc = info.categoryHierarchy) === null || _info$categoryHierarc === void 0 ? void 0 : _info$categoryHierarc.join('>')
      }, (identifiers === null || identifiers === void 0 ? void 0 : identifiers.isSuperSku) && {
        superSKU: itemId
      }), etaObj),
      quantity: '1'
    };
    if (digitalData !== null && digitalData !== void 0 && (_digitalData$cart = digitalData.cart) !== null && _digitalData$cart !== void 0 && _digitalData$cart.item && Array.isArray(digitalData === null || digitalData === void 0 ? void 0 : (_digitalData$cart2 = digitalData.cart) === null || _digitalData$cart2 === void 0 ? void 0 : _digitalData$cart2.item)) {
      // Overwrite existing cart object properties and push new item to it
      digitalData.cart = _objectSpread(_objectSpread({}, digitalData.cart), cartObj);
      digitalData.cart.item.push(cartItem);
      return;
    }
    digitalData.cart = _objectSpread(_objectSpread({}, cartObj), {}, {
      item: [cartItem]
    });
  });
};
//# sourceMappingURL=tools-materials.listener.analytics.js.map